import axiosInstance from "../Config/axiosConfig";

const getHeaders = () => {
  const accessToken = localStorage.getItem("accessToken");
  const storedDeviceId = localStorage.getItem("deviceId");
  const storedUserIp = localStorage.getItem("userIp");

  return {
    Authorization: `Bearer ${accessToken}`,
    ...(storedDeviceId && { UserDevice: storedDeviceId }),
    ...(storedUserIp && { UserIPAddress: storedUserIp }),
    "Content-Type": "application/json",
  };
};

export const fetchInvoices = async () => {
  try {
    const response = await axiosInstance.get("/Invoice/get-paid-invoices", {
      headers: getHeaders(),
    });
    console.log("check invoices having education level ID", response.data)
    let invoicesData = [];
    if (Array.isArray(response.data)) {
      invoicesData = response.data;
    } else if (
      response.data &&
      Array.isArray(response.data.data)
    ) {
      invoicesData = response.data.data;
    } else if (response.data && response.data.data) {
      invoicesData = Array.isArray(response.data.data)
        ? response.data.data
        : [response.data.data];
    } else {
      invoicesData = [response.data];
    }

    return invoicesData;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
};